import { CircularProgress, TextField } from '@mui/material'
import React from 'react'
import { com } from '@eidu/web'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import useEntityById from '../../io/useEntityById'
import Field = com.eidu.sharedlib.entity.field.Field
import entityIdFromStringOrNull = com.eidu.sharedlib.entity.entityIdFromStringOrNull

export type EntityFormReferenceDisplayProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
}

const EntityFormReferenceDisplay = ({ field, fieldValue }: EntityFormReferenceDisplayProps) => {
  const selectedId = fieldValue?.value?.let((it) => entityIdFromStringOrNull(it)) ?? undefined
  const { entity: selected, loading } = useEntityById(selectedId)
  const label = selected ? selected.primaryLabelText : ''
  const displayLoading = loading || fieldValue === undefined
  return (
    <TextField
      disabled
      required={field.required}
      label={field.name}
      value={label}
      placeholder={displayLoading ? ' ' : undefined}
      InputLabelProps={displayLoading ? { shrink: true } : undefined}
      InputProps={{
        endAdornment: loading && <CircularProgress size={30} />,
      }}
    />
  )
}

export default EntityFormReferenceDisplay
